var staticHGKeyRE = /(.+)?\[(\d+)\]$/

module.exports = staticHGKeyRE



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticHGKeyRE.js
// module id = 337
// module chunks = 98